module.exports = __webpack_public_path__ + "img/wancheng.152aca33.png";